package pwgs.ui.scenes.custompropertieseditorscene

import kotlinx.browser.window


class CustomPropertiesEditorControllerFe(props: CustomPropertiesEditorSceneProps, scene: MCustomPropertiesEditorScene) : ACustomPropertiesEditorControllerFe(props, scene) {

    override fun createInitialModel() : CustomPropertiesEditorSceneModel {
        return CustomPropertiesEditorSceneModel(listOf())
    }

    override fun init() {
        call_load()
    }

    fun onCreateNewPropertyButtonClicked() {
        model.editorModel = CustomPropertyEditorModel(false)
        render(model)
    }

    fun onCancelPropertyEditorClicked() {
        model.editorModel = null
        render(model)
    }

    fun onSubmitPropertyEditorClicked() {
        val dm = model.editorModel!!
        dm.error = null
        dm.isLoading = true
        render(model)

        if (dm.isUpdate) {
            call_update()
        } else {
            call_create()
        }
    }

    fun onEditPropertyClicked(propertyName: String, type: String, defaultValue: String, isEditable: String, isIndexed: String) {
        model.editorModel = CustomPropertyEditorModel(true)
        val d = model.editorModel!!
        d.nameFieldModel.value = propertyName
        d.typeFieldModel.value = type
        d.valueFieldModel.value = defaultValue
        d.boolValueFieldModel.value = defaultValue
        d.editableFieldModel.value = isEditable
        d.indexedFieldModel.value = isIndexed
        render(model)
    }

    fun onDeletePropertyClicked(propertyName: String) {
        if (!window.confirm("Are you sure you want to delete this property?")) {
            return;
        }
        model.isLoading = true
        render(model)

        call_delete(propertyName)
    }


}

